import { createFileRoute } from '@tanstack/react-router';
import { SqlSyncListRouteView } from '@/pages/workspaces/journeys/integrations/sql-sync/routing';
import { LastWorkspaceResolver } from './-components';

/**
 * The per-database SQL sync list, keyed by engine (`mysql`, `postgres`, `snowflake`, `bigquery`,
 * `redshift`, `sqlserver`).
 *
 * No `appBundle`: this URL has no `journeys` segment, and the bundle-aware branch of the resolver
 * rebuilds the target from the bundle prefix — which would find no `/journeys/` here, drop the
 * sub-path, and land on the Journeys home instead of this page.
 */
function SqlSyncListRoute() {
  const { type } = Route.useParams();

  return (
    <LastWorkspaceResolver>
      <SqlSyncListRouteView type={type} />
    </LastWorkspaceResolver>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/integrations/sql-sync/$type/')({
  component: SqlSyncListRoute,
});
